import React from 'react';
import { useSyncCenter } from '../../SyncCenterProvider';

export interface QueueDataStatus {
  hasPendingQueuedData: boolean;
  pendingQueuedDataCount: number;
}

export function useQueueDataChecker() {
  const services = useSyncCenter();

  const [queueDataStatus, setQueueDataStatus] = React.useState<QueueDataStatus>({
    hasPendingQueuedData: false,
    pendingQueuedDataCount: 0,
  });

  React.useEffect(() => {
    const interval = setInterval(async () => {
      setQueueDataStatus(await services.syncCenter.queuedDataStatus());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return queueDataStatus;
}
